import { render, staticRenderFns } from "./BorcluInfo.vue?vue&type=template&id=259ed98c"
import script from "./BorcluInfo.vue?vue&type=script&lang=ts"
export * from "./BorcluInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports